import theme from '@adsk/alloy-react-theme';
export const STATUS_COLORS = {
  BLUE: 'blue',
  YELLOW: 'yellow',
  GREEN: 'green',
  PURPLE: 'purple',
  RED: 'red',
  GRAY_LIGHT: 'gray-light',
  GRAY: 'gray',
  GRAY_DARK: 'gray-dark',
  WHITE: 'white',
  TURQUOISE: 'turquoise',
  DARK_BLUE: 'dark-blue'
};
export const STATUS_COLORS_MAP = {
  [STATUS_COLORS.BLUE]: theme.colors.adskBlue500,
  [STATUS_COLORS.YELLOW]: theme.colors.yellowOrange500,
  [STATUS_COLORS.GREEN]: theme.colors.green500,
  [STATUS_COLORS.PURPLE]: theme.colors.purple500,
  [STATUS_COLORS.RED]: theme.colors.red500,
  [STATUS_COLORS.GRAY_LIGHT]: theme.colors.charcoal200,
  [STATUS_COLORS.GRAY]: theme.colors.charcoal700,
  [STATUS_COLORS.GRAY_DARK]: theme.colors.charcoal900,
  [STATUS_COLORS.WHITE]: theme.colors.white,
  [STATUS_COLORS.TURQUOISE]: theme.colors.turquoise500,
  [STATUS_COLORS.DARK_BLUE]: theme.colors.darkBlue300
};
//# sourceMappingURL=consts.js.map